import { Component } from '@angular/core';

@Component({
  selector: 'app-stories',

  templateUrl: './stories.component.html',
  styleUrl: './stories.component.scss',
})
export class StoriesComponent {}
